module.exports = __webpack_public_path__ + "img/card-offer-cabbage.421c5b3f.png";